<template>
  <v-menu v-model="show" :close-on-content-click="false" offset-y origin="top center" class="elevation-0" :nudge-bottom="14" transition="scale-transition">
    <template v-slot:activator="{ on }">
      <v-btn text
             v-if="$vuetify.breakpoint.mdAndUp"
             style="text-transform: capitalize;
                    font-weight: 600;
                    font-size: 22px"
             v-on="on"
             :loading="loadingCompanies"
             :color="showManageButtons ? 'white' : 'kbDarkBlue'">
        {{ truncate(selectedApp.app_name) }}
        <v-icon right>arrow_drop_down</v-icon>
      </v-btn>

      <v-chip v-if="selectedApp.app_name && $vuetify.breakpoint.mdAndDown && showChip"
              v-on="on"
              rounded
              class="ml-2"
              :color="showManageButtons ? 'rgba(66, 121, 214, 0.3)' : 'primary'"
              style="cursor: pointer; text-overflow: ellipsis;"
              text-color="kbDark">{{ selectedApp.app_name }}</v-chip>
    </template>

    <v-card class="elevation-0">
      <v-card-text class="pa-0">
        <v-text-field solo
                      background-color="kbLight"
                      color="kbDarkBlueText"
                      autofocus
                      flat
                      clearable
                      append-icon="search"
                      :placeholder="`${$t('general.search')}...`"
                      hide-details
                      v-model="search"
                      @input="filterApps()">
        </v-text-field>
        <v-divider></v-divider>
        <v-container style="max-height: 400px"
                     class="overflow-y-auto pa-0"
                     fluid
                     >
          <v-list color="kbWhite" v-if="filteredApps.length > 0">
            <App v-for="app in filteredApps"
                 :key="app.UUID"
                 :app="app"
                 :showManageButtons="showManageButtons"
                 @closeMenu="show = false"
                 @input="$emit('input', $event)">
            </App>
          </v-list>
          <v-list color="kbWhite" v-else>
            <template>
              <v-subheader>
                <span class="kbDarkBlueText--text" v-if="search">
                  {{$t('toolbar.companyNotFound')}}
                </span>

                <span class="kbDarkBlueText--text" v-else>
                  {{$t('toolbar.appNotRegistered')}}
                </span>
              </v-subheader>
            </template>
          </v-list>
        </v-container>
        <v-divider></v-divider>
        <v-toolbar color="kbLight" dense v-if="showManageButtons">
          <v-btn block color="kbBlue" outlined @click="goto('/apps/new')">{{$t('toolbar.createAplication')}}</v-btn>
        </v-toolbar>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex'
import App from '@/components/widgets/list/App.vue'

export default {
  components: { App },
  created () {
    this.$store.dispatch('getCompanies')
    if (this.selectedCompany.UUID) {
      this.$store.dispatch('getCompany', this.selectedCompany.UUID)
    }
  },
  computed: {
    ...mapState({
      companies: state => state.companies.companies,
      loadingCompanies: state => state.companies.loadingCompanies,
      selectedCompany: state => state.companies.selectedCompany,
      selectedApp: state => state.apps.selectedApp
    }),
    apps () {
      const apps = []

      this.companies.forEach(company => {
        company.apps.forEach(app => {
          apps.push({ company: { ...company }, ...app })
        })
      })
      return apps
    },
    filteredApps () {
      if (this.search) return this.filter
      return this.apps
    }
  },
  data () {
    return {
      filter: [],
      search: '',
      show: false
    }
  },
  methods: {
    filterApps () {
      const search = this.search ? this.search.toLowerCase() : ''

      this.filter = this.apps.filter(app => {
        const appName = app.app_name.toLowerCase()
        const companyName = app.company.name.toLowerCase()
        const companyUUID = app.company.UUID
        const appUUID = app.UUID

        return appName.indexOf(search) > -1 ||
          companyName.indexOf(search) > -1 ||
          companyUUID.indexOf(search) > -1 ||
          appUUID.indexOf(search) > -1
      })
    },
    goto (route) {
      this.search = ''
      this.show = false
      this.$router.push(route)
    },
    truncate (value) {
      if (!value) return 'Seleccione un negocio'
      if (value.length > 20 && this.$vuetify.breakpoint.lgAndDown) return value.slice(0, 20) + '...'
      return value
    }
  },
  props: {
    showManageButtons: {
      type: Boolean,
      default: true
    },
    showChip: {
      default: true,
      type: Boolean
    }
  }
}
</script>
